import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../api";
import { Button } from "../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../externalComponents/tailwind/dialog";
import { CustomerContext } from "../providers";

export default function DuplicateFlow() {
  const navigate = useNavigate();
  const { customer } = useContext(CustomerContext);
  const urlParams = new URLSearchParams(window.location.search);
  const [isAutomation, setIsAutomation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorLoading, setErrorLoading] = useState(false);
  const [hasRun, setHasRun] = useState(false);
  const [shareCode, setShareCode] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shareCodeExpired, setShareCodeExpired] = useState(false);
  const [scenarioRecord, setScenarioRecord] = useState(null);

  useEffect(() => {
    const code = urlParams.get("sharecode") ?? "";
    setShareCode(code);
  }, []);

  useEffect(() => {
    (async () => {
      if (shareCode && !hasRun) {
        setHasRun(true);
        try {
          const fetchedScenarioRecord = await api.findSharedScenario({ shareCode: shareCode,});

          if (fetchedScenarioRecord) {
            setScenarioRecord(fetchedScenarioRecord);
            setIsAutomation(fetchedScenarioRecord.type === "automation");

            const shareCodeCreatedAt = new Date(
              fetchedScenarioRecord.shareCodeCreatedAt,
            );
            const now = new Date();
            const isLessThan24Hours =
              now - shareCodeCreatedAt < 24 * 60 * 60 * 1000;

            setIsModalOpen(true);
            setShareCodeExpired(!isLessThan24Hours);
          } else {
            setErrorLoading(true);
          }
        } catch (error) {
          setErrorLoading(true);
          console.log(error)
        }
      }
    })();
  }, [shareCode]);

  const handleCreateCampaign = async () => {
    if (shareCode) {
      setIsLoading(true);

      const newCampaign = await api.copyCampaignNodesAndEdges({
        oldCampaignId: scenarioRecord.campaignId,
        oldScenarioId: scenarioRecord.id,
        campaignName: scenarioRecord.name,
        isShared: true,
        shareCode: shareCode,
      });

      navigate(
        `/${isAutomation ? "automations" : "campaigns"}/edit/${newCampaign.id}`,
      );
    } else {
      setErrorLoading(true);
    }
  };

  return (
    <>
      <div
        className="h-full"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {errorLoading && !isLoading && (
          <>
            <p>This page doesn't exist</p>
            <br />
            <Button
              color="primaryButton"
              onClick={() => navigate("/dashboard")}
            >
              Back to home page
            </Button>
          </>
        )}
      </div>

      <Dialog key="dialog_load" open={isModalOpen}>
        <DialogTitle close={false}>{`Import ${
          isAutomation ? "an automation" : "a campaign"
        }`}</DialogTitle>
        <DialogBody className="flex-1 overflow-y-auto scrollbar">
          {!shareCodeExpired && (
            <>
              <p>
                You are about to import the{" "}
                {isAutomation ? "automation " : "campaign "}
                <b>{scenarioRecord?.name}</b> on the account of{" "}
                <b>{`${customer?.name}`}</b>
              </p>
            </>
          )}
          {shareCodeExpired && <p>The link is expired.</p>}
        </DialogBody>
        <DialogActions>
          <Button
            color="secondaryButton"
            onClick={() => navigate("/dashboard")}
            className="min-w-[100px] h-10"
          >
            Cancel
          </Button>
          <Button
            color="primaryButton"
            onClick={() => handleCreateCampaign()}
            className="min-w-[100px] h-10"
            disabled={shareCodeExpired}
            loading={isLoading}
          >
            {`Import the ${isAutomation ? "automation" : "campaign"}`}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
